export const UI_RETAILER_HOME_PAGE = 'retailers';
export const UI_REP_HOME_PAGE = 'representatives';
export const API_RETAILER_HOME_PAGE = 'retailer';
export const API_REP_HOME_PAGE = 'rep';
export const PRELOGIN_HOME_PAGE = 'pre_login';



// WEBPACK FOOTER //
// ./src/data/homePageTypes.js